module.exports = __webpack_public_path__ + "static/img/IMG_0899.ad8c845.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0899.jpeg
// module id = Pkiu
// module chunks = 0